var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card", attrs: { shadow: "never" } },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _vm._v(" 账单中心 "),
            _c("span", { staticClass: "sub" }, [
              _vm._v("按核销时刻聚合，与核销记录页同一口径"),
            ]),
          ]),
          _c(
            "el-form",
            {
              attrs: { inline: "", size: "small" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "粒度" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.onGranularityChange },
                      model: {
                        value: _vm.granularity,
                        callback: function ($$v) {
                          _vm.granularity = $$v
                        },
                        expression: "granularity",
                      },
                    },
                    [
                      _c("el-radio-button", { attrs: { label: "DAY" } }, [
                        _vm._v("按日"),
                      ]),
                      _c("el-radio-button", { attrs: { label: "MONTH" } }, [
                        _vm._v("按月"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "时间" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      "default-time": ["00:00:00", "23:59:59"],
                      "start-placeholder": "开始",
                      "end-placeholder": "结束",
                    },
                    model: {
                      value: _vm.dateRange,
                      callback: function ($$v) {
                        _vm.dateRange = $$v
                      },
                      expression: "dateRange",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.load(1)
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                  _c("el-button", { on: { click: _vm.reset } }, [
                    _vm._v("重置"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: {
                data: _vm.list,
                size: "small",
                border: "",
                "show-summary": "",
                "summary-method": _vm.summary,
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "序号", width: "60", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(_vm.$pageIndex(scope)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "period",
                  label: _vm.granularity === "MONTH" ? "月份" : "日期",
                  "min-width": "120",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "cnt", label: "核销笔数", width: "110" },
              }),
              _c("el-table-column", {
                attrs: { prop: "orderAmount", label: "订单金额", width: "130" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(_vm._s(_vm.yuan(row.orderAmount)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "deductPoints",
                  label: "抵扣积分",
                  width: "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "deductAmount",
                  label: "抵扣金额",
                  width: "130",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(_vm._s(_vm.yuan(row.deductAmount)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "serviceFee",
                  label: "平台服务费",
                  width: "130",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(_vm._s(_vm.yuan(row.serviceFee)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "receivable",
                  label: "商户应收",
                  "min-width": "130",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(_vm._s(_vm.yuan(row.receivable)))]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "total, sizes, prev, pager, next",
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.page.size,
                  "current-page": _vm.page.page,
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.onSizeChange,
                  "current-change": _vm.load,
                },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "tips" }, [
            _vm._v(
              " 只统计「已核销」与「部分退款」两种状态：待确认的还没扣积分，已撤销 / 已过期的反向流水都走完了。 部分退款的应收已按比例冲减过，表里就是净额，不要再减一次。 "
            ),
            _c("br"),
            _vm._v(" 合计行只汇总"),
            _c("b", [_vm._v("当前这一页")]),
            _vm._v("。要整段时间的总额请把时间区间选好、粒度切成「按月」。 "),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }